import script from "./AvatarWithCropper.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarWithCropper.vue?vue&type=script&setup=true&lang=js"

import "./AvatarWithCropper.vue?vue&type=style&index=0&id=5ce81f30&lang=scss"

const __exports__ = script;

export default __exports__